import { createSelector } from 'reselect';

import searchSelector from './search';

const DEFAULT = 1;

/**
 * make a makeCurrPageNum selector
 * @returns {Function} a makeCurrPageNum selector
 */
const makeCurrPageNum = function makeCurrPageNum() {
  return createSelector(searchSelector, search => search.currPageNum || DEFAULT);
};

export default makeCurrPageNum;
